import { FC, useState } from 'react';

import { Container, Spinner } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { BlockSection } from '../../../common/Common.styles';
import { SpeedTestContainer, SpeedTestIframe, SpeedTestIframeLoader } from './SpeedTest.styles';

const SPEED_TEST_URL = 'https://teliatest.dualstack.speedtestcustom.com/';

export const SpeedTest: FC = () => {
    const { t } = useTranslations();

    const [isLoaded, setIsLoaded] = useState(false);

    // When iframe is rendered in server side, onLoad event does not fire. Setting src dynamically to force onLoad to fire.
    const iframeNodeHandler = (iframe: HTMLIFrameElement) => {
        if (!iframe) {
            return;
        }
        iframe.src = SPEED_TEST_URL;
    };

    return (
        <Container>
            <BlockSection>
                <SpeedTestContainer>
                    <SpeedTestIframe
                        ref={iframeNodeHandler}
                        onLoad={() => setIsLoaded(true)}
                        title={t['content.block_widget.speed_test.title']}
                    />
                    <SpeedTestIframeLoader $isVisible={!isLoaded}>
                        <Spinner size="lg" />
                    </SpeedTestIframeLoader>
                </SpeedTestContainer>
            </BlockSection>
        </Container>
    );
};
